import { apiRequest } from "./apiUtils";
import { 
  BrandSearchResultDto, 
  BrandIconDto,
} from "@foodfluence/shared";
import Environment from "../../environment";

interface BrandFetchBrand {
  name: string;
  icon?: string;
  domain?: string;
  claimed?: boolean;
  brandId?: string;
}

const searchBrandFetch = async (query: string): Promise<BrandFetchBrand[]> => {
  const clientId = Environment.BRAND_FETCH_CLIENT_ID;
  if (!clientId) {
    return [];
  }
  const url = `https://api.brandfetch.io/v2/search/${encodeURIComponent(query)}?c=${clientId}`;
  const response = await fetch(url, { headers: { Accept: "application/json" } });
  if (!response.ok) {
    return [];
  }
  return response.json() as Promise<BrandFetchBrand[]>;
};

export const brandApi = {
  /**
   * Search for brands by query string
   */
  searchBrands: async (query: string): Promise<BrandSearchResultDto[]> => {
    const data = await searchBrandFetch(query);
    return data.map((brand) => ({ name: brand.name, icon: brand.icon ?? "" }));
  },

  /**
   * Get fresh brand icons for multiple brand names
   */
  getBrandIcons: async (brandNames: string[]): Promise<BrandIconDto[]> => {
    const results = await Promise.all(
      brandNames.map(async (brandName) => {
        const data = await searchBrandFetch(brandName);
        if (data.length > 0 && data[0].icon) {
          return { name: brandName, icon: data[0].icon };
        }
        return null;
      })
    );
    return results.filter((result): result is BrandIconDto => result !== null);
  },

  /**
   * Add a brand to the influencer's profile
   */
  addBrandToInfluencer: async (brandName: string, influencerId: string): Promise<void> => {
    await apiRequest({
      method: "POST",
      endpoint: "/influencer/profile/update",
      data: { brandToAdd: brandName },
      influencerId,
    });
  },

  /**
   * Remove a brand from the influencer's profile
   */
  removeBrandFromInfluencer: async (brandName: string, influencerId: string): Promise<void> => {
    await apiRequest({
      method: "POST",
      endpoint: "/influencer/profile/update",
      data: { brandToRemove: brandName },
      influencerId,
    });
  }
};
